import { Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, Grid, IconButton } from '@mui/material'
import React, { useEffect, useState } from 'react'
import DashboardContainer from '../../components/DashboardContainer'
import PageContainer from '../../components/PageContainer'
import { AddorUpdateRecord, getFields, getList } from '../../redux/api/system';
import { useHistory } from 'react-router-dom';
import { Formik, Form } from 'formik'
import { useSnackbar } from 'notistack';
import { DataGrid } from '@mui/x-data-grid'
import TextInput from '../../components/common/TextInput'
import SelectInput from '../../components/common/SelectInput'
import { Add, ApartmentOutlined, BusinessOutlined, Delete, DomainAddOutlined, Edit, Label } from '@mui/icons-material'
import { dataTypeOptions } from '../../util'
import DialogBox from '../../components/common/DialogBox';

const CreateDataset = () => {
    const [ showModal, setShowModal ] = useState(false);
    const [ responseModal, setResponseModal ] = useState(false);
    const [ responseStatus, setResponseStatus ] = useState(false);
    const [ responseContent, setResponseContent ] = useState("");

    const defaultDataset = {
        "domainID": "",
        "dataSetName": "",
        "dB_Table": "",
        "fields": [
            {
               "fieldName": "",
               "fieldMaxLenght": 0,
               "dataType": "",
               "friendlyName": ""
            },
        ],
        "type": "",
        "producer": "",
        "searchTags": "",
        "ingestMedium":"",
        "frequency":"",
        "description":"",
        "deliveryMedium": "",
        "autoCreateResource": false,
        "useExistingFieldDefinition": false,
        // "templateDatasetID": "",
    }

    const [ selectedDataset, setSelectedDataset ] = useState(defaultDataset);
    const [ domains, setDomains ] = useState([]);
    const { enqueueSnackbar } = useSnackbar();
    const [ processing, setProcessing ] = useState(false)
    const [ message, setMessage ] = useState();
    const [ datasets, setDatasets ] = useState([]);

    const defaultField = {
        "fieldName": "",
        "fieldMaxLenght": 0,
        "dataType": "",
        "friendlyName": ""
    };

    const history = useHistory();

    const addOrDeleteField = (key = null) => {
        if(key != null) {
            const newFields = selectedDataset.fields.filter((doc, index) => index !== key);
            setSelectedDataset({...selectedDataset, fields: newFields })
        } else {
            setSelectedDataset({...selectedDataset, fields: [ ...selectedDataset.fields, defaultField ] })
        }
    }

    const handleFieldChange = (name, value, key) => {
        let newDocs = [ ...selectedDataset.fields ]
        let doc = newDocs[key];
        const id = name.split(`${key}-`)[1]
        doc[id] = value;
        newDocs[key] = doc            
        setSelectedDataset({...selectedDataset, fields: newDocs })
    }

    const getDomains = async () => {
        try {
            setProcessing(true)
            const resp = await getList("domains");
            const res = await getList("datasets");
            // console.log("res", res);

            if(resp?.responseCode === "00") {
                setDomains(resp?.listing || [])
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
            }

            if(res?.responseCode === "00") {
                setDatasets(res?.listing || [])
            }
            else {
                enqueueSnackbar(res?.message || res?.responseMessage || 'An error occurred', { variant: 'error' })
            }
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
        finally {
            setProcessing(false)
        }
    }

    const createOrUpdateDataset = async (values, { resetForm }) => {
        try {
            const resp = await AddorUpdateRecord("dataset", values?.id ? "update" : 'add', values);
            if(resp?.responseCode === "00") {
                setSelectedDataset(null)
                history.push('/internal/datasets');
            } else {
                enqueueSnackbar(resp?.message || resp?.responseMessage || 'An error occurred', { variant: 'error' })
                setResponseStatus(false);
                setResponseContent(String(resp?.message || resp?.responseMessage || 'An error occurred'));
                setResponseModal(true);
            }
            setMessage(resp)
            setShowModal(false)
        }
        catch (err) {
            enqueueSnackbar(err?.message || err?.responseMessage || 'An error occurred', { variant: 'error' })
        }
    }

    useEffect(() => {
        getDomains()
    }, [])

    return (
        <PageContainer pageTitle='Create Dataset Views' processing={processing}>
            <section className="inner-banner parallax-section">
                <div className='overlay'>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-sm-12">
                                <h3 className="wow bounceIn" data-wow-delay="0.9s">Create</h3>
                                <h1 className="wow fadeInUp text-uppercase conference mb-05 mt-05" data-wow-delay="1.6s">Dataset</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="services-area section-padding pt-3">
                <div className="container">
                    <div className="row">
                        <div className='col-12 mt-4'>
                            <Formik enableReinitialize initialValues={selectedDataset} onSubmit={createOrUpdateDataset}>
                                {({ isSubmitting, values, setFieldValue }) => (
                                    <Form>
                                            <Grid container spacing={3}>
                                                <Grid item xs={12}>
                                                    <SelectInput id="domainID" required label="Domain" options={domains} field="domainID" fieldDisplay='domainName' 
                                                        customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextInput id="dataSetName" required label="Dataset Name"
                                                        customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextInput id="dB_Table" required label="Dataset Table name"
                                                        customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <TextInput id="description" label="Description" placeholder="" multiline minRows={2}
                                                        customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextInput id="searchTags" label="Search Tags" placeholder="Separate each with a comma"
                                                        customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <TextInput id="uniqueFields" label="Dataset Unique Fields" placeholder="Separate each with a comma"
                                                        customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <SelectInput required id="type" label="Dataset Type" options={[
                                                        { code: 'custom' }, 
                                                        { code: 'generic' }, 
                                                        //{ code: 'static report' }
                                                    ]} 
                                                    fieldDisplay="code" field="code"
                                                    customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <SelectInput required id="frequency" label="Dataset Frequency" options={[{ code: 'yearly' }, { code: 'quarterly' }, { code: 'monthly' }, { code: 'daily' }, { code: "bi-annually" }]} fieldDisplay="code" field="code"
                                                        customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <SelectInput required id="ingestMedium" label="Dataset Ingest Medium" options={[{ code: 'api' }, { code: 'file' }, { code: 'hybrid' }]} fieldDisplay="code" field="code"
                                                        customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <SelectInput required id="deliveryMedium" label="Dataset Delivery Medium" options={[{ code: 'api' }, { code: 'file' }, { code: 'hybrid' }]} fieldDisplay="code" field="code"
                                                        customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    {/* <FormControlLabel
                                                        control={
                                                            <Checkbox checked={values.autoCreateResource} />
                                                        }
                                                        label={<b className='f-15'>Auto create Resource from Dataset</b>}
                                                        name={"autoCreateResource"}
                                                        onChange={() => setFieldValue('autoCreateResource', !values.autoCreateResource)}
                                                    /> */}
                                                    <FormControlLabel
                                                        control={ <Checkbox  /> }
                                                        label={<b className='f-15'>Auto create Resource from Dataset</b>}
                                                        name={"autoCreateResource"}
                                                        onChange={({ target }) => {
                                                            setFieldValue('autoCreateResource', target.checked)
                                                            setSelectedDataset({ ...selectedDataset, autoCreateResource: target.checked })
                                                        }}
                                                        value={values.autoCreateResource}
                                                    />
                                                </Grid>
                                                <Grid item xs={4}>
                                                    <FormControlLabel
                                                        control={ <Checkbox  /> }
                                                        label={<b className='f-15'>Use an Existing Dataset </b>}
                                                        name={"useExistingFieldDefinition"}
                                                        onChange={({ target }) => {
                                                            setFieldValue('useExistingFieldDefinition', target.checked)
                                                            setSelectedDataset({ ...selectedDataset, useExistingFieldDefinition: target.checked })
                                                        }}
                                                        value={values.useExistingFieldDefinition}
                                                    />
                                                </Grid>
                                                {
                                                    values?.useExistingFieldDefinition &&
                                                    <Grid item xs={12} md={4}>
                                                        <SelectInput required id="templateDatasetID" label="Select Dataset to Reuse" options={datasets} fieldDisplay="dataSetName" field="id"
                                                            customChange={(name, value) => {
                                                                // console.log("value", value);
                                                                setSelectedDataset({ ...selectedDataset, [name]: value })
                                                            }} 
                                                        />
                                                    </Grid>
                                                }
                                                <Grid item xs={12}>
                                                    <TextInput id="footnote" label="Footnote" placeholder="Enter footnote (optional)" multiline minRows={2}
                                                        customChange={(name, value) => setSelectedDataset({ ...selectedDataset, [name]: value })} 
                                                    />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <div className='d-flex justify-content-space-between align-items-center'>
                                                        <label>Dataset Fields</label>
                                                    </div>
                                                        {
                                                            !values?.useExistingFieldDefinition &&
                                                            values?.fields?.map((field, key) => (
                                                                <div key={key}>
                                                                    <Divider className='mt-2 mb-2' />
                                                                    <p><b>{key + 1}.</b></p>
                                                                    <Grid container item spacing={2} xs={12}>
                                                                        <Grid item xs={12} md={6} lg={4}>
                                                                            <TextInput  
                                                                                //floatingLabel
                                                                                required={!values?.useExistingFieldDefinition}
                                                                                multiline label="Field Name" 
                                                                                preventFormikSetValue id={`${key}-fieldName`}
                                                                                value={field.fieldName}
                                                                                customChange={(name, value) => {
                                                                                    handleFieldChange(name, value, key)
                                                                                }} 
                                                                                tip="The system will not accept any special characters in the field name. Please use only alphabets, numbers and underscore."
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={6} lg={4}>
                                                                            <TextInput 
                                                                                //floatingLabel 
                                                                                required={!values?.useExistingFieldDefinition}
                                                                                multiline label="Field Friendly Name"
                                                                                preventFormikSetValue id={`${key}-friendlyName`}
                                                                                value={field.friendlyName}
                                                                                customChange={(name, value) => {
                                                                                    handleFieldChange(name, value, key)
                                                                                }} 
                                                                                tip="Naming with dataset friendly name will help in identifying the field in the system. It allows for special characters."
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <TextInput 
                                                                                // floatingLabel 
                                                                                required={!values?.useExistingFieldDefinition}
                                                                                label="Max Length" type="number" 
                                                                                preventFormikSetValue id={`${key}-fieldMaxLenght`}
                                                                                value={field.fieldMaxLenght}
                                                                                customChange={(name, value) => {
                                                                                    handleFieldChange(name, value, key)
                                                                                }} 
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4}>
                                                                            <SelectInput 
                                                                                // floatingLabel 
                                                                                required={!values?.useExistingFieldDefinition}
                                                                                label="Data Type" options={dataTypeOptions} fieldDisplay="code" field="code" 
                                                                                preventFormikSetValue id={`${key}-dataType`}
                                                                                value={field.dataType}
                                                                                customChange={(name, value) => {
                                                                                    handleFieldChange(name, value, key)
                                                                                }} 
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={2}>
                                                                            <TextInput 
                                                                                // floatingLabel 
                                                                                label="Sequence" type="number" 
                                                                                preventFormikSetValue id={`${key}-sequence`}
                                                                                value={field.sequence}
                                                                                customChange={(name, value) => {
                                                                                    handleFieldChange(name, value, key)
                                                                                }} 
                                                                            />
                                                                        </Grid>
                                                                        <Grid item xs={12} md={4} container justifyContent={'flex-end'} flexDirection="column">
                                                                            <Button color="error" startIcon={<Delete />} variant='outlined' onClick={() => addOrDeleteField(key)}>
                                                                                Remove
                                                                            </Button>
                                                                        </Grid>
                                                                    </Grid>
                                                                </div>
                                                            ))
                                                        }
                                                        <div className='d-flex justify-content-space-between align-items-center'>
                                                            <Divider className='mt-2 mb-2' />
                                                            <Button variant="outlined" color="primary" className='mt-2' onClick={() => addOrDeleteField()} startIcon={<Add />}>
                                                                Add
                                                            </Button>
                                                        </div>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Divider />
                                                </Grid>
                                                <Grid item xs={12} container justifyContent={'center'}>
                                                    <Button type='submit' variant="contained" disabled={isSubmitting}>
                                                        {
                                                            isSubmitting ?
                                                            <CircularProgress size={15} color="inherit" />
                                                            :
                                                            values?.id ? 'Update Dataset Domain' : 'Add Dataset Domain'
                                                        }
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                            {/* <Button disabled={isSubmitting} onClick={() => { if(!isSubmitting) { setShowModal(false); setSelectedDataset(null) }}} color="secondary" variant="contained" >Cancel</Button> */}
                                    </Form>
                                )}
                            </Formik>
                            {/* Dialog Box for request responses */}
                            <DialogBox isIconTitle content={responseContent} responseType={responseStatus} opener={responseModal} closer={setResponseModal} />
                        </div>
                    </div>
                </div>
            </div>

            <Dialog open={showModal}>
                <DialogContent>
                    <h3 className='text-bold' >{message}</h3>
                </DialogContent>
                <DialogActions className='pr-2 pb-2'>
                    <Button variant="contained" onClick={() => setShowModal(false)}>Close</Button>
                </DialogActions>
            </Dialog>
        </PageContainer>
    )
}

export default CreateDataset